module.exports = __webpack_public_path__ + "static/media/fuel_fee.d335f722.svg";